module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.102b0a9d.png";